export const filterAllAttributesFromVariants = (variants: Array<GQL.IProductVariant>, attributes: Array<GQL.IAttribute>) => {
  const uniqueAttributes: Array<string> = [];
  return (variants || []).reduce((data: Array<GQL.IAttribute>, variant: GQL.IProductVariant) => {
    if (variant.definition) {
      Object.keys(variant.definition).forEach((attributeId: string) => {
        // klíč je id atributu
        if (attributeId !== 'visual') {
          // atribut není dosud ve výstupu
          if (uniqueAttributes.indexOf(attributeId) === -1) {
            // najdu objekt atributu
            const attribute = attributes.find(a => a.id === attributeId);
            if (attribute) {
              // vložím do unikátních a do dat
              uniqueAttributes.push(attributeId);
              data.push(attribute);
            }
          }
        }
      });
    }

    return data;
  }, []);
};



// WEBPACK FOOTER //
// ./src/helpers/Variants/filterAllAttributesFromVariants.ts